import { Box, SimpleGrid } from "@chakra-ui/react";
import { columnsDataDevelopment } from "views/karyawan/manage_user/variables/columnsData";
import DataTableList from "./DataTableList";

export default function Settings() {
  return (
    <Box pt={{ base: "130px", md: "80px", xl: "80px" }}>
      <SimpleGrid
        mb="20px"
        columns={{ base: 1, md: 1, xl: 1 }}
        spacing={{ base: "20px", xl: "20px" }}
      >
      <Box pt={{ base: "130px", md: "80px", xl: "80px" }}>
        <DataTableList
          columnsData={columnsDataDevelopment}
          endpoint={`/users`}
        />
      </Box>
      </SimpleGrid>
    </Box>
  );
}
